exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapped-static{max-width:100%;min-width:100%;max-height:100%;min-height:100%}.divfix{bottom:15;right:0;position:fixed;z-index:3000}", ""]);

// exports
